import { getInstance } from '../../../lib/axios';
import constants from '../../../constants';

export async function getAllWorkouts() {
  try {
    const url = `${constants.endpoints.WORKOUTS_MANAGEMENT}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch all workouts failed', error.message);
    throw error;
  }
}

export async function getetUserCreatedWorkouts(id) {
  try {
    const url = `${constants.endpoints.WORKOUTS_MANAGEMENT}/user/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch user created workouts failed', error.message);
    throw error;
  }
}

export async function createWorkout(data) {
  try {
    const url = `${constants.endpoints.WORKOUTS_MANAGEMENT}`;
    const response = await getInstance().post(url, data);
    return response.data;
  } catch (error) {
    console.error('Create workout failed', error.message);
    throw error;
  }
}